import { postApi } from './api';

export const redirectToPayment = async (userEmail, userName) => {
  try {
    
    const data = await postApi('/api/create-checkout-session', {
      email: userEmail,
      name: userName
    });


    if (!data.url) {
      throw new Error('No checkout URL received');
    }

    // Redirect to Stripe checkout
    window.location.href = data.url;
    
  } catch (err) {
    console.error('Payment error:', err);
    alert('Payment system error: ' + err.message);
  }
};

export const checkPaymentStatus = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const isSuccess = urlParams.get('payment') === 'success';
  const isCancelled = urlParams.get('payment') === 'cancelled';
  const sessionId = urlParams.get('session_id');
  
  return {
    isSuccess,
    isCancelled,
    sessionId
  };
};